import { createRouter, createWebHashHistory } from 'vue-router';
import { loadI18n } from '@/infrastructure/locales'

const router = createRouter({
    history: createWebHashHistory(),
    routes: [
        {
            path: '/',
            redirect: '/create',
            beforeEnter: async(to, from, next) => {
                await loadI18n();
                next();
            },
            children: [
                {
                    path: '/create',
                    component: () => import('@/pages/Create.vue'),
                },
                {
                    path: '/page/:fmea_id',
                    component: () => import('@/pages/Page.vue'),
                }
            ],
        }
    ],
});

export default router;
